// Only browser Back/Forward restores an old scroll position. Cached list data
// keeps return visits fast, but must not send a fresh menu visit down the page.
export function scrollBehavior(to, from, savedPosition) {
  if (savedPosition) return savedPosition
  if (to.hash) return { selector: to.hash }
  const employerScreen = process.env.VUE_APP_SATELLITE === 'testcandidates' &&
    !to.matched.some(route => route.meta.assessment || route.meta.candidateWizard)
  // Assessment filters update this mounted page in place.
  if (employerScreen && to.name === 'client-assessments-list' && to.path === from.path) return false
  return { x: 0, y: 0 }
}
